import { Box, styled } from "@mui/material";
export const MyMealsMenuWrapper = styled(Box, {
    shouldForwardProp: (prop) => !["isSelectedMenuItem", "isNavDrawer"].includes(prop), // Cast `prop` to string
})(({ theme, isSelectedMenuItem, isNavDrawer }) => ({
    borderLeft: isNavDrawer && isSelectedMenuItem ? `${theme.spacing(0.75)} solid ${theme.palette.primary.main}` : "none",
    lineHeight: 1,
}));
/**
 * Sets the default props. DO NOT CHANGE.
 * If additional customizations are required, creating a new styled component is likely the better approach.
 */
MyMealsMenuWrapper.defaultProps = {
    isSelectedMenuItem: false,
    isNavDrawer: false,
};
